import { Grid } from '@mui/material';
import AndroidIcon from '@mui/icons-material/Android';
import AppleIcon from '@mui/icons-material/Apple';
import DesktopWindowsIcon from '@mui/icons-material/DesktopWindows';
import { BlockScore } from '../BlockScore';
import {
  CardPlatformContainer,
  CardPlatformScoreContainer,
} from '../FullVariants/ExposeAppCard/ExposeAppCard.styles';

const platformIconSelector = {
  ios: AppleIcon,
  android: AndroidIcon,
  web: DesktopWindowsIcon,
};

export interface AppPlatformInfoProps {
  platforms?: Array<{
    platformName: 'ios' | 'android' | 'web' | undefined;
    platformTitle: string;
    score?: number;
  }>;
  isLoading?: boolean;
}

/**
 * AppPlatformInfo component from [MicroLibraryCoreUI](https://dev.azure.com/orcha/MicroLibraryTemplate/_git/MicroLibraryCoreUI)
 *
 * @property platforms - The platforms to display.
 * @property isLoading - Whether the platforms are loading.
 */
export const AppPlatformInfo = ({
  platforms,
  isLoading,
}: AppPlatformInfoProps) => {
  if (!platforms || isLoading) {
    return null;
  }

  return (
    <Grid item xs={12} container spacing={2}>
      {platforms.map((platform) => {
        const { platformName, score, platformTitle } =
          platform;
        const IconComponent = platformName
          ? platformIconSelector[platformName]
          : undefined;

        return (
          <Grid key={platformName} item xs={4}>
            <CardPlatformContainer>
              <CardPlatformScoreContainer
                data-testid={`app-card-score-${platformName}`}
              >
                {IconComponent && (
                  <IconComponent
                    titleAccess={platformTitle}
                    sx={{ fontSize: '17px' }}
                    color="primary"
                  />
                )}
                <BlockScore score={score} />
              </CardPlatformScoreContainer>
            </CardPlatformContainer>
          </Grid>
        );
      })}
    </Grid>
  );
};
